(function(window, angular){'use strict';

var ngModule = angular.module('pp.ui.services.auth-redirect', [
    'pp.services.core',
    'pp.services.investor',
    'pp.services.route',
    'pp.ui.services.authenticate-investor'
]);

var AUTH_STAGE_INITIAL = 'initial';

/**
 * @ndgoc service
 * @description
 * Sends anonymous users to the login or signup page rather than blocking them with the
 * auth modal, carrying a return path so that authenticating brings them back to where
 * they were.
 */
ngModule.service('authRedirect', ['$q', '$window', 'investorService', 'routeService', 'ppTrack', 'authenticateInvestor', function ($q, $window, investorService, routeService, ppTrack, authenticateInvestor) {

    // -- api

    var api = {};

    /**
     * The path of the page currently being viewed, to return the user to once
     * they have authenticated.
     */
    api.getCurrentPath = function () {
        return $window.location.pathname + $window.location.search + $window.location.hash;
    };

    /**
     * Sends the user to the signup page if they have never got past the initial stage,
     * and to the login page otherwise. This is the branch the auth modal itself made.
     */
    api.toAuthPage = function (user, returnUrl, action) {
        var authPath = user.stage === AUTH_STAGE_INITIAL ? routeService.signupPath : routeService.loginPath;

        ppTrack.deferAction(action);

        return ppTrack.closeAll().then(function () {
            $window.location.href = authPath + '?returnUrl=' + encodeURIComponent(returnUrl);
        });
    };

    /**
     * Resolves with the investor when there is one. For an anonymous user it redirects to
     * the auth page and returns a promise that never settles, so that the calling chain
     * stops rather than running its error handler while the browser is navigating away.
     *
     * This is the drop in replacement for authenticateInvestorAnonReject. The user is known
     * not to be anonymous by the time authenticateInvestor is called, so it never reaches
     * the auth modal, it only runs the extra user data check that authenticating carried.
     */
    api.requireInvestor = function (returnUrl, action) {
        return investorService.getInvestor().then(function (user) {
            if (!user.anon) {
                // Note early return
                return authenticateInvestor();
            }

            api.toAuthPage(user, returnUrl, action);

            return $q.defer().promise;
        });
    };

    return api;
}]);
})(window, window.angular);